import { useEffect, useRef } from "react";
import * as signalR from "@microsoft/signalr";
import { APIURL } from "./APIURL";

export function useDashboardSignalR(onUpdate) {
  const connectionRef = useRef(null);
  const onUpdateRef = useRef(onUpdate);

  useEffect(() => {
    onUpdateRef.current = onUpdate;
  }, [onUpdate]);

  useEffect(() => {
    const hubBase = APIURL.replace(/\/api\/?$/i, "");

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${hubBase}/realTimeHub`)
      .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
      .configureLogging(signalR.LogLevel.Warning)
      .build();

    connectionRef.current = connection;

    connection.on("ReceiveUpdate", () => {
      console.log("Dashboard SignalR: ReceiveUpdate fired — refreshing KPI cards");
      onUpdateRef.current();
    });

    connection
      .start()
      .then(() => console.log("Dashboard SignalR connected"))
      .catch((err) => console.warn("Dashboard SignalR connect error:", err));

    return () => {
      connection.stop();
    };
  }, []);
}
